import { loadInternalAddresses } from '@/routing/internalAddressLoad';
import { launchesNarrow, loadPhoneChrome } from './loadPhoneChrome';
import { loadShellRuntime } from './loadShellRuntime';
import { isShellRuntime } from './shellDetection';

/**
 * I-2453: the chunks a launch awaits before its first render, side by side, so what that first screen
 * draws is on its first frame and nothing arrives after the page and moves it. A narrow window loads
 * the phone rows, bottom bar and menu (`loadPhoneChrome.ts`); the app shell loads its runtime
 * (`loadShellRuntime.tsx`) and the route table (`internalAddressLoad.ts`), so a link there is never a
 * document load. A desktop launch in a browser loads none of them. Read after the shell session, as
 * in the app the idiom decides.
 */
export function loadLaunchChunks(): Promise<unknown> {
  const inShell = isShellRuntime();
  return Promise.allSettled([
    launchesNarrow() ? loadPhoneChrome() : undefined,
    inShell ? loadShellRuntime() : undefined,
    inShell ? loadInternalAddresses() : undefined,
  ]);
}
